import "core-js/stable"; // TODO is this required? (See answer below)
import "regenerator-runtime/runtime";
import "@aevi-pd/aevi-styles/dist/styles.css";
import "./core/styles/index.less";

import { createRoot } from "react-dom/client";

import { AppEntry } from "./AppEntry";

const container = document.getElementById("app");

if (!container) {
    throw new Error("Root container not found");
}

const root = createRoot(container);
root.render(<AppEntry />);
